<div *ngIf="loading" class="loader">
    <div class="loader-table-container">
        <div class="spinner-border text-secondary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>

<router-outlet></router-outlet>